// extracted by mini-css-extract-plugin
export default {"tabletMinViewport":"768px","desktopMinViewport":"1024px","smallScreenHeight":"970px","textTitle":"LmykHU","textSubtitle":"F5INiE","textDisclaimer":"e2U7F9","generateButton":"dnwQEk"};